import { render, staticRenderFns } from "./LocationInfo.vue?vue&type=template&id=c55dc4d8&scoped=true"
import script from "./LocationInfo.vue?vue&type=script&lang=js"
export * from "./LocationInfo.vue?vue&type=script&lang=js"
import style0 from "./LocationInfo.vue?vue&type=style&index=0&id=c55dc4d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c55dc4d8",
  null
  
)

export default component.exports